<template>
  <div class="kvass-media-types-help-trigger">
    <ButtonComponent
      :label="`${$t('tourVideoUpload')} ? `"
      tag="a"
      target="_blank"
      :href="`https://help.kvass.no/nb/articles/${triggerId}`"
    />
  </div>
</template>

<script>
import { ButtonComponent } from 'vue-elder-button'
export default {
  data() {
    return {
      triggerId: 14451,
    }
  },
  components: {
    ButtonComponent,
  },
}
</script>

<style lang="scss">
.kvass-media-types-help-trigger {
  margin-top: 1rem;
  display: flex;
  justify-content: flex-end;
  font-size: 0.75em;
  opacity: 0.7;
  padding: 0px 5px;
}
</style>
